import React, { useMemo } from 'react'
import {
  faExclamationSquare,
  faFileUpload,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { IBlockInstanceModel } from 'models/block.model'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface TooltipProps {
  isValidated: boolean
  block: IBlockInstanceModel
}

export function Tooltip({ isValidated, block }: TooltipProps) {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.tooltips',
  })

  const text = useMemo(() => {
    if (!block.file) return t('emptyScorm')
    return t(
      !isValidated && !block.processing && !block.file
        ? 'invalidScorm'
        : 'processed'
    )
  }, [t, isValidated, block])

  return (
    <CommonToolTip text={text} position={'right'}>
      <FontAwesomeIcon
        size={'xs'}
        className="ml-1"
        icon={!isValidated ? faExclamationSquare : faFileUpload}
      />
    </CommonToolTip>
  )
}

export default Tooltip
